module.exports = __webpack_public_path__ + "static/media/plus.0269b918.svg";